// extracted by mini-css-extract-plugin
module.exports = {"tableBodyContainer":"VirtualTableBody-tableBodyContainer-1l4zq"};